
import MdContent from 'components/md-content'


export default {
  components: {MdContent},
  data(){
    return {
      md: undefined,
      active: 'markdown',
      tabs: [
        {value: 'markdown', title: 'Markdown'},
        {value: 'raw', title: 'Raw text'}
      ]
    }
  },
  computed: {
    chat_width() {
      const boxStyles = getComputedStyle(document.body)
      const chat_width = boxStyles.getPropertyValue('--chat-width').trim()

      // chat width + modal offset
      return `calc(${chat_width} + 3.4rem)`
    }
  },
  methods: {
    open(data) {
      this.md = data
      this.active = 'markdown'
      this.$refs.modal.open()
    },
    close() {
      this.md = undefined
      this.$refs.modal.close()
    }
  }
}
